// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.display-flex > *[data-v-1d1a559a] {\n  margin-bottom: 0.5rem;\n}\n.filters-list[data-v-1d1a559a] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.header-content[data-v-1d1a559a] {\n  flex-wrap: wrap;\n}\n.header-content button[data-v-1d1a559a] {\n  height: 40px;\n}\n.color-white[data-v-1d1a559a] {\n  color: #fff;\n  margin-top: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
